<template>
  <div class="feedback-group-wrapper" v-if="!is_active">
    <div class="feedback-group-inner header border-bottom">
      <h2>Zadajte hodnotených a pridajte vzťahy</h2>
    </div>
    <FeedbackEditRelationsEvaluated
      v-for="evaluatedRelations in relationsByEvaluated"
      :key="evaluatedRelations.evaluated.customer_id"
      :evaluatedId="evaluatedRelations.evaluated.customer.id"
      :evaluatedFirstName="evaluatedRelations.evaluated.customer.name"
      :evaluatedLastName="evaluatedRelations.evaluated.customer.lastname"
      :relations="evaluatedRelations.relations"
      :participantById="participantById"
      ref="formRelations"
    />
    <div class="feedback-group-inner">
      <div class="evaluated-person">
        <div>
          <div class="custom-select">
            <select @change="addEvaluated">
              <option disabled selected value="next">Vyberte ďalšieho hodnoteného</option>
              <option
                v-for="evaluated in participantsNotEvaluated"
                :key="evaluated.customer_id"
                :value="evaluated.customer_id"
              >{{evaluated.customer.name}} {{evaluated.customer.lastname}}</option>
            </select>
          </div>
        </div>
        <div>
          <label>
            <input type="checkbox" v-model="newEvaluatedSelfEvaluation" /> Sebahodnotenie
          </label>
        </div>
        <div></div>
      </div>
    </div>
    <div class="actions right">
      <button class="button big" @click="saveForm">Uložiť zmeny</button>
    </div>
  </div>
</template>

<script>
import FormBase from "../../elements/FormBase";
import FeedbackEditRelationsEvaluated from "./FeedbackEditRelationsEvaluated";
import { mapState, mapGetters } from "vuex";
import feedbackApi from "../../api/feedback";

export default {
  components: { FeedbackEditRelationsEvaluated },
  props: ["is_active", "is_editing_participants", "courseId"],
  mixins: [FormBase],
  data() {
    return {
      newEvaluatedSelfEvaluation: false,
      createWithSelfEvaluated: []
    };
  },
  created() {
    this.refresh();
  },
  methods: {
    refresh() {
      this.$store.dispatch("feedback/loadRelationTypes");
      this.$store.dispatch("feedback/loadAllRelations");
    },
    addEvaluated(event) {
      const evaluatedId = parseInt(event.target.value);
      if (isNaN(evaluatedId)) {
        return;
      }

      this.$store.commit("feedback/addEditedEvaluated", { evaluatedId });

      if (this.newEvaluatedSelfEvaluation) {
        this.createWithSelfEvaluated = [
          ...this.createWithSelfEvaluated,
          evaluatedId
        ];
      }

      event.target.value = "next";
      this.newEvaluatedSelfEvaluation = false;
    },
    saveForm() {
      const dto = this.$refs.formRelations
        .map(el => ({
          evaluatedId: el.evaluatedId,
          relations: el.myRelations.filter(
            r => typeof r.relationId === "undefined"
          ),
          deleted: el.deletedRelations
        }))
        .filter(
          rels => !(rels.relations.length == 0 && rels.deleted.length == 0)
        );
      if (dto.length > 0) {
        feedbackApi
          .postSaveRelationsForm({
            courseId: this.courseId,
            formData: dto
          })
          .then(result => {
            if (result.data.ok) {
              this.$store.dispatch("feedback/loadAllRelations").then(_ => {
                this.$refs.formRelations.forEach(r => {
                  r.resetData.call(r);
                });
              });
            }
          });
      } else {
        this.$api.toaster.fail({ txt: "Neurobili ste zmenu." });
      }
    }
  },
  computed: {
    ...mapState({
      relationTypes: state => state.feedback.relationTypes,
      participants: state => state.feedback.participants,
      participantsNotEvaluated: state =>
        state.feedback.participants.filter(participant => {
          return (
            !state.feedback.relations.some(
              rel => rel.evaluated_id == participant.customer_id
            ) &&
            !state.feedback.editedEvaluated.includes(participant.customer_id)
          );
        }),
      participantById: state =>
        state.feedback.participants.reduce((out, p) => {
          return { ...out, [p.customer_id]: p };
        }, {}),

      relationsByEvaluated(state) {
        return state.feedback.participants.reduce(
          (accumulator, participant) => {
            let relations = state.feedback.relations
              .filter(fr => fr.evaluated_id == participant.customer_id)
              .map(fr => ({
                ...fr,
                evaluating: state.feedback.participants.find(
                  x => fr.evaluating_id === x.customer_id
                )
              }));

            if (
              this.createWithSelfEvaluated.indexOf(participant.customer_id) !==
              -1
            ) {
              relations = [
                ...relations,
                {
                  roleId: null,
                  evaluated_id: participant.customer_id,
                  evaluating_id: participant.customer_id
                }
              ];
            }
            if (
              state.feedback.editedEvaluated.indexOf(
                participant.customer_id
              ) !== -1 ||
              (!!relations && relations.length > 0)
            ) {
              return [
                ...accumulator,
                {
                  evaluated: participant,
                  relations: relations
                }
              ];
            } else {
              return accumulator;
            }
          },
          []
        );
      }
    })
  }
};
</script>



// WEBPACK FOOTER //
// src/public_app/pages/feedback/FeedbackEditRelations.vue